// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Coin1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Coin1/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.267 13.958c-.275 2.217-2.092 4.034-4.309 4.309a4.949 4.949 0 0 1-3.566-.917c-.559-.408-.425-1.275.241-1.475a7.905 7.905 0 0 0 5.25-5.25c.2-.658 1.067-.792 1.475-.242a5.016 5.016 0 0 1 .909 3.575Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.325 1.667a6.661 6.661 0 0 0-6.658 6.658 6.661 6.661 0 0 0 6.658 6.658 6.661 6.661 0 0 0 6.658-6.658C14.975 4.65 12 1.667 8.325 1.667Zm-.783 5.725 2.008.7c.725.258 1.075.766 1.075 1.55 0 .9-.717 1.641-1.592 1.641h-.075v.042a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-.05c-.925-.042-1.666-.817-1.666-1.783a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625c0 .3.216.541.483.541h1.25c.192 0 .342-.175.342-.391 0-.292-.05-.309-.242-.375l-2.008-.7c-.717-.25-1.075-.759-1.075-1.55 0-.9.716-1.642 1.591-1.642h.075v-.033a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v.05c.925.041 1.667.816 1.667 1.783A.63.63 0 0 1 10 7.8a.63.63 0 0 1-.625-.625c0-.3-.217-.542-.483-.542h-1.25c-.192 0-.342.175-.342.392-.008.283.042.3.242.367Z"
}));
export default Coin1Icon;